/**院校中心模块 */
import request from '../request/http';
/**新增课程 */
export function CollegePageList(data){
    return request({
        url: '/sp/schoolConfig/pageList',
        method: 'post',
        data
    })
}
/**删除院校配置 */
export function DelCollegeConfig(data){
    return request({
        url: '/sp/schoolConfig/del',
        method: 'post',
        data
    })
}
/**更新院校配置 */
export function UpdateCollegeConfig(data){
    return request({
        url: '/sp/schoolConfig/upd',
        method: 'post',
        data
    })
}
/**分页查询院校 */
export function PageSchoolList(data){
    return request({
        url: '/sp/schoolConfig/pageSchoolList',
        method: 'post',
        data
    })
}